export var NavSections;
(function (NavSections) {
  NavSections["USERS"] = "USERS";
  NavSections["EFFLUENT"] = "EFFLUENT";
  NavSections["CUSTOMERS"] = "CUSTOMERS";
  NavSections["GROUPS"] = "GROUPS";
  NavSections["IRRIGATORS"] = "IRRIGATORS";
  NavSections["SOILMOISTURE"] = "SOILMOISTURE";
  NavSections["HOMEPAGE"] = "HOMEPAGE";
  NavSections["WATERINFRASTRUCTURE"] = "WATERINFRASTRUCTURE";
  NavSections["WATERNETWORK"] = "WATERNETWORK";
  NavSections["LINK_DEVICE_TO_EXISTING"] = "LINK_DEVICE_TO_EXISTING";
  NavSections["SUPPORT"] = "SUPPORT";
})(NavSections || (NavSections = {}));